import { CommonLookupItem } from '../../../shared/models/common-lookup-item.model';
import { RangeFilter } from '../../../shared/models/range.model';

import { Serializable } from '../../../core/models/serializable';
export class AnnouncementFilterModel
  implements Serializable<AnnouncementFilterModel>
{
  fromObject(obj: any): AnnouncementFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      SelectedCustomerIdList:
        this.selectedCustomerIdList &&
        this.selectedCustomerIdList.map((s) => s.id),
      SelectedCategoryIdList: this.selectedCategoryIdList,
      SelectedStatusId: this.selectedStatusId,
      SearchText: this.searchText,
      AccountManagerId: this.accountManagerId,
      AnnouncementTitle: this.announcementTitle,
      PortfolioId: this.portfolioId,
      ProviderWebsiteId: this.providerWebsiteId,
      PublishDate: this.publishDate && this.publishDate.toObject(),
      DeadlineDate: this.deadlineDate && this.deadlineDate.toObject(),
      Id: this.id,
      ApplicationEmail: this.applicationEmail,
      LogDate: this.logDate,
      ModerationStatus: this.moderationStatus,
      PublishStatus: this.onWebsite,
    };
    return result;
  }

  public selectedCustomerIdList: CustomerOptionList[];
  public selectedCategoryIdList: number[];
  public selectedStatusId: number;
  public searchText: string;
  public announcementTitle: string;
  public providerWebsiteId: number;
  public moderationStatus: number;
  public publishDate: RangeFilter<Date>;
  public deadlineDate: RangeFilter<Date>;
  public id: string;
  public logDate: RangeFilter<Date>;
  public applicationEmail: string;
  public accountManagerId: number;
  public portfolioId: number;
  public onWebsite: number;
}

export interface CustomerOptionList {
  id: string;
  label: string;
}
